import {
  PARTNER_FETCH,
  PARTNER_FETCH_SUCCESS,
  PARTNER_FETCH_FAIL,
  PARTNER_SAVE,
  PARTNER_SAVE_SUCCESS,
  PARTNER_SAVE_FAIL,
  FETCH_PARTNER_USERS,
  FETCH_PARTNER_USERS_SUCCESS,
  FETCH_PARTNER_USERS_FAIL
} from '../constants/ActionTypes';

export function partnerFetch(partnerID) {
  return {
    type: PARTNER_FETCH,
    partnerID
  };
}

export function partnerFetchSuccess(partner) {
  return {
    type: PARTNER_FETCH_SUCCESS,
    partner
  };
}

export function partnerFetchFail(error) {
  return {
    type: PARTNER_FETCH_FAIL,
    error
  };
}

export function partnerSave(partnerID, data, translate) {
  return {
    type: PARTNER_SAVE,
    partnerID,
    data,
    translate
  }
}

export function partnerSaveSuccess(payload) {
  return {
    type: PARTNER_SAVE_SUCCESS,
    payload
  }
}

export function partnerSaveFail(payload) {
  return {
    type: PARTNER_SAVE_FAIL,
    payload
  }
}

export const fetchPartnerUsers = partnerID => ({
  type: FETCH_PARTNER_USERS,
  partnerID
});

export const fetchPartnerUsersSuccess = users => ({
  type: FETCH_PARTNER_USERS_SUCCESS,
  users
});

export const fetchPartnerUsersFail = error => ({
  type: FETCH_PARTNER_USERS_FAIL,
  error
});

